import styled, { css } from "styled-components";

const Centered = styled.div`
    top: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
`;

export default Centered;
